import { CardProps, Flex } from '@opendoor/bricks/core';
import { DisplayCard } from 'sellDirect/components/legacy/sellerDash/exteriorAssessment/DisplayCard';
import React from 'react';

/** TODO: Add documentation */
export const WrapperCard: React.FC<
  {
    onlyShowCta?: boolean;
  } & CardProps
> = ({ children, onlyShowCta, ...props }) => (
  <Flex justifyContent="center" alignItems="center" width="100%" {...props}>
    <DisplayCard
      flexDirection="column"
      borderRadius="roundedSquare"
      boxShadow={onlyShowCta ? 'none' : 'small'}
      justifyContent="center"
      alignItems="center"
      maxWidth={['325px', '450px']}
      width="100%"
      py={onlyShowCta ? 0 : 4}
      px={5}
      bg="neutrals0"
    >
      {children}
    </DisplayCard>
  </Flex>
);
